@if (showCard()) {
<div class="aggregate-card--expansion-container">
    <forge-expansion-panel #smartCardCollection [open]="aggregate.isEmphasized"
        (forge-expansion-panel-toggle)="expandAggregate($event)" [attr.telemetry]="aggregateProviderId">
        <forge-toolbar slot="header" style="position: relative;" tabindex="0" role="button">
            @if (getIcon()) {
            <forge-icon slot="before-start" [name]="getIcon()" [ngClass]="iconClass" class="aggregate-card--icon">
            </forge-icon>
            }
            <div slot="start" fxLayout="column" fxLayoutAlign="start start">
                <div class="forge-typography--heading2 aggregate-card--header">
                    {{aggregate.Name}} ({{aggregateCount}})
                </div>
                <div class="forge-typography--subheading1 aggregate-card--header-summary">
                    {{summary}}
                </div>
            </div>
            <div slot="end" fxLayout="column" fxLayoutAlign="start start">
                <forge-icon-button (click)="hideSmartCard()" telemetry="Hide Smart Card" aria-label="Hide Smart Card">
                    <forge-tooltip>Hide Smart Card</forge-tooltip>
                    <forge-icon name="visibility_off"></forge-icon>
                </forge-icon-button>
            </div>
            @if (showCardCommands) {
            <div slot="end" layout-column>
                <command-menu [commands]="cardCommands" icon="more_vert" telemetry="Edit-CardCommands">
                </command-menu>
            </div>
            }
            @if (hasCardActions) {
            <div slot="end" fxLayout="row" fxLayoutAlign="end center">
                @for (action of aggregate.CardActions; track action) {
                <div>
                    @if (isTextButton(action)) {
                    <forge-button dense (click)="cardActionClicked(action, $event)"
                        [aria-label]="getAriaLabelForCardAction(action)">
                        {{action.label}}
                    </forge-button>
                    }
                    <forge-icon-button dense (click)="cardActionClicked(action, $event)"
                        [aria-label]="getAriaLabelForCardAction(action)">
                        <forge-tooltip>{{action.label}}</forge-tooltip>
                        <forge-icon [name]="action.icon"></forge-icon>
                    </forge-icon-button>
                </div>
                }
            </div>
            }
            <forge-open-icon class="aggregate-card--open-icon" slot="after-end"></forge-open-icon>
            <forge-focus-indicator inward focus-mode="focus"></forge-focus-indicator>
            <forge-state-layer></forge-state-layer>
        </forge-toolbar>
        <div class="aggregate-card--detail">
            <div style="outline:none;" telemetry="Submission-StopPropagation">
                @for (cardData of shownCards; track cardData; let last = $last) {
                <card-elements [aggregate]="aggregate" [cardData]="cardData" [chartConfiguration]="chartConfiguration"
                    [color]="color" (reloadAggregate)="onReloadAggregate($event)"
                    (actionPerformedEvent)="handleCardAction($event)" class="no-pointer">
                </card-elements>
                <forge-divider></forge-divider>
                }
                @if (subAggregates) {
                <div>
                    <aggregate-collection [aggregates]="subAggregates"
                        (actionPerformedEvent)="handleCardAction($event)">
                    </aggregate-collection>
                </div>
                }
            </div>
            <div>
                @if (isLoadingCards) {
                <forge-linear-progress></forge-linear-progress>
                }
                @if (canShowMore) {
                <div fxLayout="column" fxLayoutAlign="center center">
                    <forge-icon-button dense (click)="showMore($event)" aria-label="Show more">
                        <forge-tooltip>Show more</forge-tooltip>
                        <forge-icon name="chevron_double_down"></forge-icon>
                    </forge-icon-button>
                    <forge-divider style="width: 100%;"></forge-divider>
                </div>
                }
            </div>
        </div>
    </forge-expansion-panel>
    <a #downloadAnchor fxHide></a>
</div>
}